import React from "react"

export default React.createClass({
  render() {
    const onClick = event => {
      if (window.$ && $("#modal").modal) {
        $("#modal").modal({
          remote: this.props.remote
        })
        event.preventDefault()
      }
    }
    return (
      <a href={this.props.href} target="_blank" onClick={onClick}>
        {this.props.children}
      </a>
    );
  }
});



// WEBPACK FOOTER //
// ./app/webpack/frontend/components/ReactModalOpener.jsx